import React from "react";
import styled from "styled-components";

const FormRemark = ({ children, ...props }) => {
  return (
    <Text {...props}>
      {children}
    </Text>
  );
};

const Text = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: var(--aia-bx-gray-50);
  display: inline-flex;
`;

export default FormRemark;